module.exports = __webpack_public_path__ + "media/icon-arrow-left-white.a0eb1b3a.svg";